__turbopack_context__.v({
  "fade-in": "BulletSeparatedList-module-scss-module__th2HDq__fade-in",
  "item": "BulletSeparatedList-module-scss-module__th2HDq__item",
  "list": "BulletSeparatedList-module-scss-module__th2HDq__list",
  "no-transform": "BulletSeparatedList-module-scss-module__th2HDq__no-transform",
  "rotate": "BulletSeparatedList-module-scss-module__th2HDq__rotate",
  "separator": "BulletSeparatedList-module-scss-module__th2HDq__separator",
});
